<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Report</h1>
                <p>Ci sono {{ get().length }} timbrate registrate nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="handleModal(undefined, 'create')">Aggiungi</button>
                <button type="button" class="btn btn-primary ml-3" (click)="downloadReportCsv()">Scarica report</button>
            </div>
        </div>
    </div>

    <!-- FILTRI -->

    <div class="row mb-3" id="accordion">
        <div class="col">
            <div class="card">
                <div class="card-header" id="filters_header">
                    <h5 class="mb-0">
                        <button class="btn btn-primary" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" (click)="filter_expanded = !filter_expanded">
                            Mostra filtri<i class="fas ml-3" [ngClass]="{'fa-chevron-down': !filter_expanded, 'fa-chevron-up': !!filter_expanded}"></i>
                        </button>
                    </h5>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="filters_header" data-parent="#accordion">
                    <div class="card-body pb-0">
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona gruppo</label>
                                <select name="group_select" id="group_select" class="form-control" [(ngModel)]="filter.group" (change)="populateCollection()">
                                    <option value="">-</option>
                                    <option [value]="group.id" *ngFor="let group of window.usher.get()?.public_configuration?.groups; index as i">{{ group.name }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona cliente</label>
                                <select name="client_select" id="client_select" class="form-control" [(ngModel)]="filter.client" (change)="populateCollection()">
                                    <option value="">-</option>
                                    <option [value]="window.usher.getPublicToken()">{{ window.usher.getPublicConfiguration()?.nome }}</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'cliente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona dipendente</label>
                                <select name="worker_select" id="worker_select" class="form-control" [(ngModel)]="filter.worker" (change)="populateCollection()">
                                    <option value="">-</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'dipendente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label>Da</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker_filter_from.show()">{{ window.flowup.utils.getDateTime(filter.from) }}</span>
                            </div>
                            <div class="col-12 col-md-4">
                                <label>A</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker_filter_to.show()">{{ window.flowup.utils.getDateTime(filter.to) }}</span>
                            </div>
                            <div class="col-12 col-md-4">
                                <label>Filtro di ricerca</label>
                                <input type="text" class="form-control" id="filter_text" name="filter_text" [(ngModel)]="filter.text" (keyup)="populateCollection()">
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                <button type="button" class="btn btn-primary float-right" (click)="resetFilter()">Resetta filtri</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="table-responsive-md">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">Dipendente</th>
                            <th scope="col">Cliente</th>
                            <th scope="col">Sede</th>
                            <th scope="col">Entrata</th>
                            <th scope="col">Uscita</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row cursor-pointer" *ngFor="let timbrata of get(); index as i" (click)="handleModal(timbrata.id, 'update')">
                            <td scope="col">{{ getUsers(timbrata.owner)[0]?.public_configuration?.nome || "Non rilevato" }}</td>
                            <td scope="col">{{ getUsers(timbrata.client)[0]?.public_configuration?.nome || "Non rilevato" }}</td>
                            <td scope="col">{{ getAssegnazioni(timbrata?.assegnazione)?.configuration?.sede || "Non rilevata" }}</td>
                            <td scope="col">{{ window.flowup.utils.getDateTime(timbrata?.inizio?.timestamp) }}</td>
                            <td scope="col">{{ window.flowup.utils.getDateTime(timbrata?.fine?.timestamp) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<span id="timbrataModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ queryparams()['type'] == 'create' ? "Aggiungi timbrata" : "Timbrata" }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="row mb-4" [hidden]="!getTimbrata().assegnazione">
                        <div class="col">
                            <div class="card cursor-pointer background-hover" (click)="openSelectAssegnazione()">
                                <div class="card-body">
                                    <p><b>Dipendente:</b> {{ getAssegnazioni(getTimbrata().assegnazione)?.configuration?.dipendente?.nome }}</p>
                                    <p><b>Cliente:</b> {{ getAssegnazioni(getTimbrata().assegnazione)?.configuration?.cliente?.nome }}</p>
                                    <p><b>Sede:</b> {{ getAssegnazioni(getTimbrata().assegnazione)?.configuration?.sede || "Non rilevata" }}</p>
                                    <p><b>Geolocalizzazione:</b> {{ !!getAssegnazioni(getTimbrata().assegnazione)?.geolocation_requested ? 'Richiesta' : 'Non richiesta' }}</p>
                                    <span *ngFor="let cal of getAssegnazioni(getTimbrata().assegnazione)?.configuration?.calendar; let j = index">
                                        <p>Data inizio: {{ window.flowup.utils.getDate(cal.data_inizio) }}</p>
                                        <p>Dalle {{ window.flowup.utils.getTimeFromMinutes(cal.ora_inizio) }} alle {{ window.flowup.utils.getTimeFromMinutes(cal.ora_fine) }}</p>
                                        <p>Frequenza: {{ cal.frequenza }}</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <button type="button" class="btn btn-primary w-100" (click)="openSelectAssegnazione()">Seleziona assegnazione</button>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <div class="col-12">
                            <hr>
                        </div>
                    </div>

                    <form>
                        <div class="form-row">
                            <!-- DATETIME PICKER PER CAMBIARE/AGGIUNGERE GLI ORARI DI ENTRATA E USCITA -->
                            <div class="form-group col-md-6">
                                <label>Data e ora di entrata</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker1.show()">{{ getSingleOrario('inizio') }}</span>
                            </div>
                            <div class="form-group col-md-6">
                                <label>Data e ora di uscita</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker2.show()">{{ getSingleOrario('fine') }}</span>
                            </div>
                        </div>

                        <div class="row mt-2 mb-2">
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12" [hidden]="!getAssegnazioni(getTimbrata()?.assegnazione)?.configuration?.geolocation_requested">
                                <h5><i class="fas fa-exclamation-triangle mr-2"></i>Attenzione! Questa assegnazione richiede la geolocalizzazione!</h5>
                            </div>
                            <!-- AUTOCOMPLETE PER L'INSERIMENTO DEGLI INDIRIZZI -->
                            <div class="form-group col-sm-12 col-md-6">
                                <input type="text" class="form-control col-12" id="indirizzo_autocomplete_inizio" placeholder="Inscerisci un nuovo indirizzo di entrata">
                            </div>
                            <div class="form-group col-sm-12 col-md-6">
                                <input type="text" class="form-control col-12" id="indirizzo_autocomplete_fine" placeholder="Inscerisci un nuovo indirizzo di uscita">
                            </div>

                            <!-- INDIRIZZI INSERITI -->
                            <div class="form-group col-sm-12 col-md-6" [hidden]="!getTimbrata()?.inizio?.position?.length || getTimbrata()?.inizio.position[0] == 0 && getTimbrata()?.inizio.position[1] == 0">
                                <button type="button" class="btn btn-primary w-100" (click)="openMap('inizio')">Visualizza entrata</button>
                            </div>
                            <div class="form-group col-sm-12 col-md-6" [hidden]="!getTimbrata()?.fine?.position?.length || getTimbrata()?.fine.position[0] == 0 && getTimbrata()?.fine.position[1] == 0">
                                <button type="button" class="btn btn-primary w-100" (click)="openMap('fine')">Visualizza uscita</button>
                            </div>
                        </div>
                    </form>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="handleTimbrata()">{{ queryparams()['type'] == 'create' ? "Aggiungi" : queryparams()['type'] == 'update' ? "Aggiorna" : ""}}</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="assegnazioneModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Seleziona assegnazione</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSelectAssegnazione()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-12 mb-4" *ngFor="let assegnazione of getAssegnazioni(); let i = index">
                            <div class="card">
                                <div class="card-body">
                                    <p><b>Dipendente:</b> {{ assegnazione.configuration?.dipendente?.nome }}</p>
                                    <p><b>Cliente:</b> {{ assegnazione.configuration?.cliente?.nome }}</p>
                                    <p><b>Sede:</b> {{ assegnazione.configuration?.sede }}</p>
                                    <p><b>Geolocalizzazione:</b> {{ !!assegnazione.configuration?.geolocation_requested ? 'Richiesta' : 'Non richiesta' }}</p>
                                    <span class="form-control cursor-pointer background-hover mb-2" (click)="selectAssegnazione(assegnazione.public_token, cal.id)" *ngFor="let cal of assegnazione.configuration?.calendar; let j = index">
                                        Inizio il {{ window.flowup.utils.getDate(cal.data_inizio) }} con frequenza {{ cal.frequenza }} dalle {{ window.flowup.utils.getTimeFromMinutes(cal.ora_inizio) }} alle {{ window.flowup.utils.getTimeFromMinutes(cal.ora_fine) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeSelectAssegnazione()">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteTimbrataModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Conferma</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(getTimbrata().id, 'update')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <p>Cancellando la timbrata...</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(getTimbrata().id, 'update')">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>